import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnpsHelpModalModule } from '../enps-help-modal/enps-help-modal.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EnpsHelpComponent } from './enps-help.component';

@NgModule({
  declarations: [EnpsHelpComponent],
  imports: [CommonModule, ModalModule, EnpsHelpModalModule],
  exports: [EnpsHelpComponent],
})
export class EnpsHelpModule {}
